/**
 * FAIXA NUMÉRICA de filtro de lista — a peça que `/quotes` estreou para valor
 * de documento e que `/catalog` reusa para PREÇO.
 *
 * ─── AS DUAS REGRAS QUE ERRAM EM SILÊNCIO ───────────────────────────────────
 *
 * **(a) `null` é SEM LIMITE, nunca zero.** É o `Number('') === 0` do #35c num
 * lugar novo: colapsar os dois transforma "sem mínimo" em "no mínimo zero", que
 * só é a mesma coisa enquanto não existir item de valor negativo — e um item de
 * catálogo com preço zero (brinde, cortesia) é legítimo e sumiria do recorte
 * "sem mínimo" sem ninguém entender por quê.
 *
 * **(b) Valor ilegível NÃO é recortado.** Sumir com uma linha por causa de um
 * número estranho é pior do que mostrá-la fora da faixa pedida: o usuário não
 * teria como saber que ela existe. Mesma decisão do `matchesPeriod` de
 * `quoteListFilters`.
 *
 * O parser é o mesmo `quoteTotalNumber` (#123a) porque o problema é o mesmo: o
 * número chega como `number` do formulário e como STRING com ponto do PostgREST
 * (`numeric`), e um `Number()` cru aceitaria `'0x10'` como 16.
 */
import { quoteTotalNumber } from '@/lib/quotesListSummary';

export interface ListValueRange {
  /** `null` = sem limite. NUNCA `0`, que é um limite de verdade. */
  min: number | null;
  max: number | null;
}

export const EMPTY_LIST_RANGE: ListValueRange = { min: null, max: null };

export function hasListRange(range: ListValueRange): boolean {
  return range.min !== null || range.max !== null;
}

/** `value` bruto (número ou string do PostgREST). Ver (a) e (b) no cabeçalho. */
export function matchesListRange(value: unknown, range: ListValueRange): boolean {
  if (!hasListRange(range)) return true;
  const parsed = quoteTotalNumber(value);
  if (range.min !== null && parsed < range.min) return false;
  if (range.max !== null && parsed > range.max) return false;
  return true;
}
